/**
 * Tag React component
 * 
 * @author    Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import React from 'react';
import PropTypes from 'prop-types';
import Chip from "@material-ui/core/Chip";
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
    chip: {
        margin: "8px 4px",
        height: "auto"
    },
    deleteIcon: {
        margin: "1px",
        width: "0.9em"
    },
    label: {
        paddingLeft: "10px",
        paddingRight: "5px",
    },
    labelReadonly: {
        paddingLeft: "6px",
        paddingRight: "6px"
    },
    colorSecondary: {
        color: "#999",
        //backgroundColor: "#bbbbbb",
        borderColor: "#999"
    }
});


/**
 * A Tag is a React component for displaying a single deletable tag
 *
 * @author Maurizio Tidei
 */
class Tag extends React.Component {

    render() {

        const { classes } = this.props;

        return (
            <Chip
                label={this.props.label}
                className={classes.chip}
                classes={{deleteIcon: classes.deleteIcon, label: this.props.onDelete ? classes.label : classes.labelReadonly, colorSecondary: classes.colorSecondary}}
                onClick={this.props.onClick}
                onDelete={this.props.onDelete}
                color={this.props.onDelete ? "primary" : "secondary"}
                variant={this.props.onDelete ? "outlined" : "outlined"}
                clickable={this.props.onClick ? true : false}
            />
        );
    }
}

Tag.propTypes = {
    label: PropTypes.string.isRequired,
    onDelete: PropTypes.func,
    onClick: PropTypes.func
};

export default withStyles(styles)(Tag);